import { useState } from "react";
import FirebaseKey from "../../components/FirebaseKey/FirebaseKey";
import PageLayout from "../../components/Layout/PageLayout";
import Toast from "../../components/Toast/Toast";
import { sendContactForm } from "../../core/services/contact.service";
import FirebaseService from "../../core/services/firebase.service";

const Contact = () => {
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState<{
    type: "success" | "error";
    title: string;
    description: string;
  } | null>(null);

  const isFormValid =
    phone.trim() !== "" && email.trim() !== "" && message.trim() !== "";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!isFormValid || isSubmitting) return;

    setIsSubmitting(true);
    try {
      await sendContactForm({
        email: email.trim(),
        msisdn: phone.trim(),
        message: message.trim(),
      });

      setToast({
        type: "success",
        title: FirebaseService.getValue(FirebaseService.contact_success_title),
        description: FirebaseService.getValue(
          FirebaseService.contact_success_desc
        ),
      });

      // Reset form
      setPhone("");
      setEmail("");
      setMessage("");
    } catch (error) {
      setToast({
        type: "error",
        title: FirebaseService.getValue(FirebaseService.contact_fail_title),
        description: FirebaseService.getValue(
          FirebaseService.contact_fail_desc
        ),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageLayout>
      {toast && (
        <Toast
          type={toast.type}
          title={toast.title}
          description={toast.description}
          onClose={() => setToast(null)}
        />
      )}
      <div className="pb-4">
        <h2 className="text-[32px] font-medium text-black text-start">
          <FirebaseKey firebaseKey={FirebaseService.contact_header} />
        </h2>
      </div>
      <div className="mx-auto w-full">
        <form onSubmit={handleSubmit} className="space-y-2">
          {/* Phone Number Field */}
          <div>
            {/* <label className="block text-sm font-medium text-gray-500 mb-2">
              <FirebaseKey firebaseKey={FirebaseService.contact_phone} />
            </label> */}
            <input
              type="tel"
              placeholder={FirebaseService.getValue(
                FirebaseService.contact_phone
              )}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full px-4 py-3 rounded-4xl bg-[#807e7d1f] border-none text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Email Field */}
          <div>
            {/* <label className="block text-sm font-medium text-gray-500 mb-2">
              <FirebaseKey firebaseKey={FirebaseService.contact_mail} />
            </label> */}
            <input
              type="email"
              placeholder={FirebaseService.getValue(
                FirebaseService.contact_mail
              )}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-4xl bg-[#807e7d1f] border-none text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Message Field */}
          <div>
            {/* <label className="block text-sm font-medium text-gray-500 mb-2">
              <FirebaseKey firebaseKey={FirebaseService.contact_message} />
            </label> */}
            <textarea
              placeholder={FirebaseService.getValue(
                FirebaseService.contact_message
              )}
              rows={6}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full px-4 py-3 rounded-4xl bg-[#807e7d1f] border-none text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
            />
          </div>

          {/* Send Button */}
          <div className="flex justify-center">
            <button
              type="submit"
              disabled={!isFormValid || isSubmitting}
              className="w-max max-w-md bg-[#08F] text-white py-3 px-6 rounded-4xl font-medium transition-colors active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100"
            >
              <FirebaseKey firebaseKey={FirebaseService.contact_send_button} />
            </button>
          </div>
        </form>
      </div>
    </PageLayout>
  );
};

export default Contact;
